export default __webpack_public_path__ + "static/media/mail.f87817c8.svg";